module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M9.8 55.4h109.1c5.2 0 9.2-4 9.2-8.6s-4-8.6-9.2-8.6H9.8c-5.2 0-9.2 4-9.2 8.6s4 8.6 9.2 8.6zm108.4 17.2H9.2c-5.2 0-9.2 4-9.2 8.6s4 8.6 9.2 8.6h109.1c5.2 0 9.2-4 9.2-8.6-.1-4.6-4.1-8.6-9.3-8.6zm0 34.4H9.2C4 107 0 111 0 115.6s4 8.6 9.2 8.6h109.1c5.2 0 9.2-4 9.2-8.6-.1-4.5-4.1-8.6-9.3-8.6zM9.8 21h109.1c5.2 0 9.2-4 9.2-8.6s-4-8.6-9.2-8.6H9.8c-5.2 0-9.2 4-9.2 8.6s4 8.6 9.2 8.6z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/inline-text/justify-icon.svg
// module id = 1242
// module chunks = 0